/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_DownloadInputs */

const en_cc_download = /** @type {(inputs: Cc_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download extension 1.0.0 (.zip)`)
};

const id_cc_download = /** @type {(inputs: Cc_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh ekstensi 1.0.0 (.zip)`)
};

/**
* | output |
* | --- |
* | "Download extension 1.0.0 (.zip)" |
*
* @param {Cc_DownloadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_download = /** @type {((inputs?: Cc_DownloadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_DownloadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_download(inputs)
	return en_cc_download(inputs)
});